import type { Column, ColumnKey } from './SampleDataColumns.js'

const headerLabels: Record<ColumnKey, string> = {
  mergeStatus: 'Merged',
  pipelineStatus: 'State',
  otuCount: 'Features',
  itemType: 'Type',
  customerSampleName: 'CustomerSampleId',
  files: 'Contents',
  literature: 'Primer Literature',
  forwardPrimer: 'Forward Primer',
  reversePrimer: 'Reverse Primer',
  forwardPrimerRequested: 'Forward Primer (C)',
  reversePrimerRequested: 'Reverse Primer (C)',
  sampleCoordinates: 'Coordinates',
  actions: '',
  filler: '',
  samplingDate: 'Sampling Date',
  samplingStart: 'Sampling Start',
  samplingEnd: 'Sampling End',
  matrixType: 'Matrix Type',
  extractionKit: 'Extraction Kit',
  trapType: 'Trap Type',
  collectionType: 'Collection Type',
  sequencer: 'Sequencer',
  sequencingChemistry: 'Sequencing Chemistry',
  sequencingDepth: 'Sequencing Depth',
  localityType: 'Locality Type',
  habitatType: 'Habitat Type',
  custom: 'Custom',
  select: '',
}

export const headerOf: (key: ColumnKey) => Column = (key) => ({
  label: headerLabels[key],
  type: key
})

export const headersSampleOrNC: Column[] = [
  headerOf("itemType"),
  headerOf('customerSampleName'),
  headerOf('files'),
  headerOf('literature'),
  headerOf('forwardPrimer'),
  headerOf('reversePrimer')
]

export const headersMetadata: Column[] = [
  headerOf("mergeStatus"),
  headerOf('customerSampleName'),
  headerOf('forwardPrimerRequested'),
  headerOf('reversePrimerRequested'),
]
